import * as React from 'react'
import { useEffect } from 'react'
import { useDrop } from 'react-dnd'
import { FILE } from '@disco/constants/ItemTypes'
import { getFilesFromDraggedItem } from '@disco/utils/file-utils'

type Props = {
  onDrop: (files: File[]) => void
  onOver?: (isOver: boolean) => void
  multiple?: boolean
  overlay?: React.ReactNode
  children: React.ReactNode
  disabled?: boolean | null
  className?: string
}

export default function FileDropWrapper({
  onDrop,
  onOver,
  multiple,
  overlay,
  children,
  disabled,
  className,
}: Props) {
  const [{ isOver }, dropRef] = useDrop<any, unknown, { isOver: boolean }>(
    () => ({
      accept: FILE,
      drop: draggedItem => {
        if (!draggedItem?.items) {
          return
        }
        getFilesFromDraggedItem(draggedItem).then((files: File[]) => {
          if (files.length > 0) {
            onDrop(multiple ? files : [files[0]])
          }
        })
      },
      collect: monitor => ({ isOver: monitor.isOver() }),
    }),
    [multiple, onDrop],
  )

  useEffect(() => {
    if (!disabled) {
      onOver?.(isOver)
    }
  }, [disabled, isOver, onOver])

  if (disabled) {
    return children
  }

  return (
    <div ref={dropRef} className={className}>
      {isOver ? <span>{overlay}</span> : null}
      <div style={{ opacity: isOver ? 0.5 : 1 }}>{children}</div>
    </div>
  )
}
